module.exports = __webpack_public_path__ + "img/avatar-boy.363fef20.png";